module.exports = __webpack_public_path__ + "assets/f0bb84e33b2f04f778a4c0f1a78b3477.mp3";